import { useState, useCallback } from "react";
import { notification } from "antd";
import { get } from "lodash";
import Requester from "../common/network/http/Request";
import endpoints from "../configs/endpoints";

const ITEMS_PER_PAGE = 20;

/**
 * @method useNotification
 * @summary useNotification hook
 * @returns {Object}  The helpers helpers for managing notifications info
 */
const useNotification = () => {
  const [isFetchingNotifications, setIsFetchingNotifications] = useState(false);
  const [isDeletingNotification, setIsDeletingNotification] = useState(false);
  const [notifications, setNotifications] = useState();
  const [hasNotifications, setHasNotifications] = useState(false);

  /**
   * @method onFetchNotifications
   */
  const onFetchNotifications = useCallback(async (page = 1, pageSize = ITEMS_PER_PAGE) => {
      setIsFetchingNotifications(true);

      try {
        const res = await Requester.get(endpoints.notification.getNotifications, {
          page,
          page_size: pageSize,
        });
        if (!get(res, "error")) {
          setNotifications(res.data);
          setHasNotifications(!!res?.data?.data?.length);
        }
      } catch (err) {
        setHasNotifications(false);
        notification.error({
          message: "Error",
          description: "An error has ocurred while fetching notifications",
        });
      } finally {
        setIsFetchingNotifications(false);
      }
    }, []);

  /**
   * @method onDeleteNotification
   */
  const onDeleteNotification = useCallback(async (id) => {
    setIsDeletingNotification(true);

    try {
      const res = await Requester.delete(endpoints.notification.deleteNotification(id));
      if (res.status === 202) {
        onFetchNotifications();
      }
    } catch (err) {
      notification.error({
        message: "Error",
        description: "An error has ocurred while deleting the notification",
      });
    } finally {
      setIsDeletingNotification(false);
    }
  }, []);

  return {
    isFetchingNotifications,
    isDeletingNotification,
    notifications,
    onFetchNotifications,
    onDeleteNotification,
    hasNotifications,
  };
};

export default useNotification;
